module.exports = __webpack_public_path__ + "img/naver.193250e5.svg";